'use client';

import { Button, Group, rem } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useMentorSearchStore } from '@/stores/useMentorSearchStore';

export function MentorSearchBackButton() {
  const router = useRouter();
  // Start with false to match SSR and avoid hydration errors
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    // Only check client-only APIs after component mounts
    const cameFromSearch = sessionStorage.getItem('cameFromMentorSearch') === 'true';
    const referrer = document.referrer;
    // Show back button if we came from mentor search
    const referrerCheck = referrer.includes('/mentors') && !referrer.includes('/mentors/');
    const shouldShow = cameFromSearch || referrerCheck;
    
    setCanGoBack(shouldShow);
  }, []);

  const handleBack = () => {
    // Don't clear the flag here - the search page will clear it after scroll restoration
    router.back();
  };

  if (!canGoBack) return null;

  return (
    <>
      {/* Mobile: Icon only button */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.7 }}
        style={{
          position: 'absolute',
          top: '-0.5rem',
          left: '0.5rem',
          zIndex: 10,
        }}
        className="mobile-back-button"
      >
        <Button
          variant="subtle"
          color="gray"
          onClick={handleBack}
          size="sm"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            padding: '0.5rem',
            minWidth: 'auto',
            width: '36px',
            height: '36px',
          }}
        >
          <IconArrowLeft size={18} />
        </Button>
      </motion.div>

      {/* Desktop: Icon + text button */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.7 }}
        style={{
          position: 'absolute',
          top: '1rem',
          left: '1rem',
          zIndex: 10,
        }}
        className="desktop-back-button"
      >
        <Button
          variant="subtle"
          color="gray"
          leftSection={<IconArrowLeft size={16} />}
          onClick={handleBack}
          size="sm"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          Back to search
        </Button>
      </motion.div>
    </>
  );
}
